import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useState } from 'react';
import Context from '../context/form-context';
import { tratarRetornoCamposBackend } from '../helpers/funcoesAuxiliares';
import { removerDependenteController } from '../infraestrutura/infraestrutura';
import { useFormikContext } from 'formik';
import {
    categoriaBodyTemplate,
    nomeBodyTemplate,
    parentescoBodyTemplate
} from './FormValor';
import Swal from 'sweetalert2';
import { showMessageSuccess } from '../../others/toastr';

export const DataTableDependentes = ({ carregarCamposFormulario, estaSubmetendo, dependentePagador }) => {
    const [dependenteSelecionado, setDependenteSelecionado] = useState(null);
    const {
        setSubmitting,
        resetForm
    } = useFormikContext();
    const { state, setState } = useContext(Context);
    const { editar, dependentes } = state;

    const scrollToForm = () => {
        const nome = document.getElementById('Nome');

        nome.scrollIntoView({
            behavior: 'smooth',
            inline: 'nearest',
            block: 'center'
        });

        setTimeout(() => nome.focus(), 1000);
    };

    const handleEdit = rowData => {
        const {
            Seq,
            Nome,
            CPF,
            Telefone,
            Email,
            DepSexo,
            ['CategoriaParentesco.Categoria']: Categoria,
            ['GrauParentesco.Grau']: ParentescoValue,
            Parentesco: ParentescoUpSell,
            Categoria: CategoriaUpSell,
            Idade,
            Nascimento: nascimentoLinha,
            CaracteristicasPet,
            PesoPet,
            TipoPet,
            CorPet,
            Porte,
            ['Associado.Plano']: Plano,
            valor: ValorDependente,
            Pagador
        } = rowData;

        dependentePagador(Pagador);

        const [dia, mes, ano] = nascimentoLinha.split('/');
        const dataTratada = new Date(ano, mes - 1, dia);
        const objEdicaoSemNulos = tratarRetornoCamposBackend({
            Seq,
            Nome,
            Telefone,
            CPF,
            Email,
            DepSexo,
            Categoria: Categoria ?? CategoriaUpSell,
            Parentesco: ParentescoValue?.trim() ?? ParentescoUpSell?.trim(),
            Idade,
            Nascimento: nascimentoLinha === '' ? null : dataTratada,
            CaracteristicasPet,
            PesoPet,
            TipoPet,
            CorPet,
            Porte,
            Plano: Plano?.trim(),
            ValorDependente,
            Pagador
        });

        setState({
            ...state,
            arrayMsgsValidacoesPlano: [],
            objComparadorEdicao: objEdicaoSemNulos
        });
        carregarCamposFormulario(objEdicaoSemNulos);

        if (!editar) {
            setState({
                ...state,
                arrayMsgsValidacoesPlano: [],
                objComparadorEdicao: objEdicaoSemNulos,
                editar: true
            });
        }

        scrollToForm();
    };

    const handleRemoverDependente = async rowData => {
        setSubmitting(true);

        const {
            Seq,
            Inscricao
        } = rowData;

        const result = await Swal.fire({
            title: 'Confirmação de Exclusão',
            text: 'Deseja realmente excluir este dependente?',
            showCancelButton: true,
            confirmButtonColor: '#0d730d',
            cancelButtonColor: '#1b42cd',
            cancelButtonText: 'Não',
            confirmButtonText: 'Sim'
        });

        if (result.isConfirmed) {
            await removerDependenteController(Inscricao, Seq, state.subGrupoSelecionadoUpSell);

            resetForm();
            setSubmitting(false);
            setState({
                ...state,
                dependentes: [],
                arrayMsgsValidacoesPlano: [],
                recarregarTabelaDependentes: true
            });
            showMessageSuccess('Sucesso', 'Dependente excluido com sucesso!', 'toast-top-center');
        }

        setSubmitting(false);
    };

    const acoesDeManutencaoDependente = rowData => (
        <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                <Button
                    label="Editar"
                    type="button"
                    iconPos="left"
                    className="p-button-success"
                    disabled={estaSubmetendo}
                    onClick={() => {
                        handleEdit(rowData);
                    }}
                />
            </div>
            <div className="p-col-12 p-md-6 p-lg-6 p-sm-6">
                <Button
                    label="Excluir"
                    iconPos="left"
                    className="p-button-danger"
                    disabled={estaSubmetendo}
                    type="button"
                    onClick={() => {
                        handleRemoverDependente(rowData);
                    }}
                />
            </div>
        </div>
    );

    return (
        <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-12">
                <h1>Dependentes:</h1>
            </div>
            <div className="p-col-12 p-md-12 size-spinner">
                <DataTable
                    dataKey="Seq"
                    selection={dependenteSelecionado}
                    onSelectionChange={e => setDependenteSelecionado(e.value)}
                    autoLayout
                    style={{ textAlign: 'center' }}
                    value={dependentes}
                    paginator={false}
                    sortField="data"
                    loading={estaSubmetendo}
                    loadingIcon="pi pi-spin pi-spinner"
                    sortOrder={1}
                >
                    <Column field="Seq" header="Seq" />
                    <Column
                        field="Nome"
                        header="Nome"
                        body={nomeBodyTemplate}
                        style={{
                            width: 'auto',
                            textAlign: 'left'
                        }}
                        headerStyle={{
                            width: '14em',
                            textAlign: 'center'
                        }}
                    />
                    <Column
                        field={['CategoriaParentesco.Descricao']}
                        header="Categoria"
                        body={categoriaBodyTemplate}
                    />
                    <Column
                        field="Parentesco"
                        header="Parentesco"
                        body={parentescoBodyTemplate}
                    />
                    <Column field="Nascimento" header="Nascimento" />
                    <Column
                        field="valor"
                        header="Valor"
                        body={rowData =>
                            new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(rowData.valor)
                        }
                    />
                    <Column
                        header="Ações"
                        body={acoesDeManutencaoDependente}
                        headerStyle={{
                            width: '14em',
                            textAlign: 'center'
                        }}
                        bodyStyle={{
                            textAlign: 'center',
                            overflow: 'visible'
                        }}
                    />
                </DataTable>
            </div>
        </div>
    );
};
